import Slider from 'react-slick';
import PlanCard from './PlanCard';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const PlanCarousel = ({ plans, isStudent, isPersonalTraining }) => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4, 
    slidesToScroll: 1,
    arrows: true,
    draggable: true,
    swipe: true,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1280,
        settings: { slidesToShow: 3 },
      },
      {
        breakpoint: 1024,
        settings: { slidesToShow: 2 },
      },
      {
        breakpoint: 640,
        settings: { slidesToShow: 1 },
      },
    ],
  };

  return (
    <div className="flex justify-center bg-slate-100">
      <div className="w-full max-w-[1300px] bg-slate-100">
        <Slider
          {...settings}
          className="px-8 bg-slate-100" // ✅ add padding inside slider
        >
          {plans.map((plan, idx) => (
            <div key={idx} className="px-2 bg-slate-100"> {/* ✅ equal spacing both sides */}
              <PlanCard
                {...plan}
                isStudent={isStudent}
                isPersonalTraining={isPersonalTraining}
              />
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default PlanCarousel;
